import { Button, DialogV2, Typography } from '@recruit-robin/robin-theme/web-components';
import { useContext } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialog } from 'stores/global-dialogs/hooks/useGlobalDialog';
import { useGlobalDialogData } from 'stores/global-dialogs/hooks/useGlobalDialogData';
import { useIsGlobalDialogOpen } from 'stores/global-dialogs/hooks/useIsGlobalDialogOpen';
import { useStyles } from './DiscardChangesModal.styles';

export const DiscardChangesModal = () => {
  const isVisible = useIsGlobalDialogOpen(GlobalDialogType.DiscardChangesModal);
  const modal = useGlobalDialog(GlobalDialogType.DiscardChangesModal);
  const data = useGlobalDialogData({ dialogType: GlobalDialogType.DiscardChangesModal, isVisible });
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);

  const handleKeepEditing = () => {
    data?.onKeepEditing?.();
    modal.close();
  };

  const handleDiscardChanges = () => {
    data?.onDiscardChanges?.();
    modal.close();
  };

  return (
    <DialogV2.Root isVisible={isVisible} customCss={classes.root}>
      <DialogV2.Backdrop />
      <DialogV2.Content customCss={classes.content}>
        <DialogV2.Header>
          <Typography variant={(v) => v.heading[3]} color={(c) => c.neutral.variant[80]}>
            {dictionary.discardChangesModalTitle}
          </Typography>
        </DialogV2.Header>
        <DialogV2.Body>
          <Typography variant={(v) => v.body.long} color={(c) => c.neutral.variant[70]}>
            {dictionary.discardChangesModalDescription}
          </Typography>
        </DialogV2.Body>
      </DialogV2.Content>
      <DialogV2.Footer>
        <Button label={dictionary.keepEditing} onClick={handleKeepEditing} style="text" type="subtle2" />
        <Button label={dictionary.discardChanges} onClick={handleDiscardChanges} style="filled" type="danger" />
      </DialogV2.Footer>
    </DialogV2.Root>
  );
};
